import { getBladeTimeline, STAGES } from '@/constants/blade';
import EfScrollAni from '@/efscrollani';
import getDefaultHeader from '@/utils/singUtil/getDefaultHeader';
import getHostApi from '@/utils/singUtil/getHostApi';
import { useGlobal } from '@/utils/useGlobal';
import CrowdFunding from './crowdfunding';
import Detail from './detail';
import Treaser from './treaser';

// 两种场景可以使用lazy 或 dynamic 1.非首屏渲染的模块（包含条件渲染）2.拆包大小并且做seo优化可以使用 ssr: true
//const Treaser: any = dynamic(() => import('./teaser'), { ssr: true });
//const CrowdFunding: any = dynamic(() => import('./crowdfunding'), { ssr: true });
//const Detail: any = dynamic(() => import('./detail'), { ssr: true });

export default function BladePC({ productDetail, resProductCatagory, callBackTheme, supportData, ecoflowflag, ecoflowflag2, ecoflowflag3, tabChange }: any) {
    const { useRef, getSystemTime, useState, useRouter, useEffect } = useGlobal();
    const router = useRouter();
    const { locale } = router;

    const TIMELINE = getBladeTimeline(locale, ecoflowflag3 || ecoflowflag2);
    // 服务器时间
    const serverTimeStamp: any = useRef(getSystemTime());
    // 倒计时三个时间段
    const startTimeStamp: number = new Date(TIMELINE?.teaser || 0).getTime();
    const middleTimeStamp: number = new Date(TIMELINE?.crowdfunding || 0).getTime();
    const stage2TimeStamp: number = new Date(TIMELINE?.crowdfunding_stage2 || 0).getTime();
    const endTimeStamp: number = new Date(TIMELINE?.detail || 0).getTime();
    // 计时器
    const timer: any = useRef(null);

    const props = {
        productDetail,
        resProductCatagory,
        nowSysTime: serverTimeStamp.current,
        crowdfundingTimeline: {
            stage1: middleTimeStamp,
            stage2: stage2TimeStamp,
            end: endTimeStamp,
        },
        supportData,
    };

    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }

    const [curStage, setCurStage] = useState(() => {
        // 测试环境serverTimeStamp获取会异常， 异常时纠正
        if (serverTimeStamp.current < 1000000) {
            serverTimeStamp.current = new Date().getTime();
        }
        // 详情阶段
        if (ecoflowflag || (serverTimeStamp.current >= endTimeStamp && endTimeStamp !== 0)) {
            return STAGES.DETAIL;
        }
        if (ecoflowflag2 || (serverTimeStamp.current >= middleTimeStamp && middleTimeStamp !== 0)) {
            return STAGES.CRODWFUNDING;
        }
        // 预热阶段
        if (serverTimeStamp.current >= startTimeStamp && startTimeStamp !== 0) {
            return STAGES.TEASER;
        }
        return STAGES.UNKNOWN;
    });

    const onVisibleChange = async () => {
        if (window.document.visibilityState === 'visible') {
            serverTimeStamp.current = getSystemTime();
            // 测试环境异常
            if (serverTimeStamp?.current < 1000000) {
                (async () => {
                    const API_HOST = getHostApi(locale).NEXT_PUBLIC_API_HOST;
                    const headers: any = getDefaultHeader(locale);

                    try {
                        const spuData = await fetch(`${API_HOST}/serverTimestamp?locale=${locale}`, {
                            headers,
                        });
                        const globalData = await spuData.json();
                        serverTimeStamp.current = globalData?.data?.timestamp || new Date().getTime();
                    } catch (e) {
                        console.log(e);
                    }
                })();
            }
        }
    };

    useEffect(() => {
        // 测试环境异常
        if (serverTimeStamp?.current < 1000000) {
            (async () => {
                const API_HOST = getHostApi(locale).NEXT_PUBLIC_API_HOST;
                const headers: any = getDefaultHeader(locale);

                try {
                    const spuData = await fetch(`${API_HOST}/serverTimestamp?locale=${locale}`, {
                        headers,
                    });
                    const globalData = await spuData.json();
                    serverTimeStamp.current = globalData?.data?.timestamp || new Date().getTime();
                } catch (e) {
                    console.log(e);
                }
            })();
        }
        // 倒计时结束完成之前一直执行定时器任务
        if (
            (serverTimeStamp.current < endTimeStamp && endTimeStamp !== 0) ||
            (serverTimeStamp.current < middleTimeStamp && middleTimeStamp !== 0 && endTimeStamp === 0)
        ) {
            timer.current = setInterval(() => {
                serverTimeStamp.current += 1000;
                // 详情阶段
                if (ecoflowflag || (serverTimeStamp.current >= endTimeStamp && endTimeStamp !== 0)) {
                    // 当前阶段本就是详情时，不需要set，否则会引起不必要的重绘重排，定时器任务每秒一次，严重影响性能
                    curStage !== STAGES.DETAIL && setCurStage(STAGES.DETAIL);
                    // 倒计时结束
                    return clearInterval(timer.current);
                }
                // 众筹阶段
                if (ecoflowflag2 || (serverTimeStamp.current >= middleTimeStamp && middleTimeStamp !== 0)) {
                    if (endTimeStamp === 0) {
                        clearInterval(timer.current);
                    }
                    return curStage !== STAGES.CRODWFUNDING && setCurStage(STAGES.CRODWFUNDING);
                }
                // 预热阶段
                if (serverTimeStamp.current >= startTimeStamp && startTimeStamp !== 0) {
                    if (endTimeStamp === 0 && middleTimeStamp === 0) {
                        clearInterval(timer.current);
                    }
                    return curStage !== STAGES.TEASER && setCurStage(STAGES.TEASER);
                }
                // 预热开始前阶段: 有预热、无预热有众筹、无预热无众筹
                if (
                    (serverTimeStamp.current < startTimeStamp && startTimeStamp !== 0) ||
                    (serverTimeStamp.current < middleTimeStamp && startTimeStamp === 0 && middleTimeStamp !== 0) ||
                    (serverTimeStamp.current < endTimeStamp && startTimeStamp === 0 && middleTimeStamp === 0 && endTimeStamp !== 0)
                ) {
                    return router.push('/404');
                }
            }, 1000);
        } else {
            clearInterval(timer.current);
        }
        if (typeof window !== 'undefined') {
            // 监听切屏事件
            window.document.addEventListener('visibilitychange', onVisibleChange);
        }
        return () => {
            clearInterval(timer.current);
        };
    }, []);

    useEffect(() => {
        callBackTheme(curStage === STAGES.CRODWFUNDING ? 'white' : 'black');
        return () => {
            AniContainer?.destroy();
        };
    }, []);

    return (
        <>
            {curStage === STAGES.TEASER && <Treaser />}
            {curStage === STAGES.CRODWFUNDING && (
                <CrowdFunding
                    {...props}
                    tabChange={(val: string) => {
                        tabChange(val);
                    }}
                />
            )}
            {curStage === STAGES.DETAIL && <Detail />}
        </>
    );
}
